import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconSocialLinkedinProps } from './IconSocialLinkedin.types'
import * as Styled from './styles/IconSocialLinkedin.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSocialLinkedin: FC<IconSocialLinkedinProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSocialLinkedinProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconSocialLinkedinProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M19.633 3H4.375C3.617 3 3 3.617 3 4.375v15.262A1.377 1.377 0 0 0 4.375 21h15.262A1.375 1.375 0 0 0 21 19.633V4.375c0-.758-.613-1.371-1.367-1.375ZM8.48 18.352H5.832v-8.47H8.48ZM7.16 8.703a1.527 1.527 0 1 1 0-3.055h.012a1.528 1.528 0 1 1-.012 3.055Zm11.2 9.649h-2.645v-4.125c0-.989-.02-2.25-1.387-2.25-1.398 0-1.613 1.078-1.613 2.18v4.198h-2.649V9.883h2.559v1.148h.035c.356-.672 1.227-1.367 2.508-1.367 2.691 0 3.191 1.75 3.191 4.04Zm0 0'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconSocialLinkedin
